import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import axios from 'axios'
import { subtotalStore } from '@/stores/v2/subtotal'
import { notification } from 'ant-design-vue'
import { CompletionThreeElement } from '@/types/v2/completion3/completionThreeElement'
import { CompletionThreeProduct } from '@/types/v2/completion3/completionThreeProduct'
import { headerStore } from '@/stores/header'

export const completion3Store = defineStore('v2/completion3', () => {
  const loading = ref(false)
  const saving = computed(() => savingProductId.value > 0)
  const savingProductId = ref(0)
  const phaseState = ref('loading')
  const phaseClosed = computed(() => ['closed', 'processed', 'expired'].includes(phaseState.value) || headerStore().ordersReceived.completion)

  const elements = ref<CompletionThreeElement[]>([])

  const hasSelectedProducts = computed(() =>
    elements.value
      .flatMap(element => element.products)
      .filter(product => product.selected).length > 0
  )

  function getCompletion3Products () : void {
    loading.value = true
    axios.get(process.env.VUE_APP_API_URL_V2 + '/completion3').then((r) => {
      elements.value = r.data
    }).finally(() => {
      loading.value = false
    })
  }

  function toggleProduct (id:number, qty:number) : void {
    savingProductId.value = id
    axios.post(process.env.VUE_APP_API_URL_V2 + '/completion3/' + id, { qty: qty }).then((r) => {
      elements.value = r.data
    }).finally(() => {
      subtotalStore().getSubtotals()
      savingProductId.value = 0
    })
  }

  function updateProductQty (product:CompletionThreeProduct, qty:number) : void {
    if (product.selected && qty) {
      savingProductId.value = product.id
      axios.patch(process.env.VUE_APP_API_URL_V2 + '/completion3/' + product.id, { qty: qty }).then((r) => {
        elements.value = r.data
        notification.success({
          message: 'Aantal succesvol aangepast.',
          description: 'Het aantal van "' + product.commercial_name + '" is succesvol aangepast naar ' + qty + '.',
          duration: 5
        })
      }).catch(() => {
        notification.error({
          message: 'Aantal niet aangepast!',
          description: 'Het aantal van "' + product.commercial_name + '" is NIET aangepast. Probeer het later nog een keer.'
        })
      }).finally(() => {
        subtotalStore().getSubtotals()
        savingProductId.value = 0
      })
    }
  }

  function getPhaseState () : void {
    axios.get(process.env.VUE_APP_API_URL + '/phase/2/closed').then((r) => {
      phaseState.value = r.data.status
    })
  }

  return {
    loading,
    saving,
    savingProductId,
    phaseState,
    phaseClosed,
    elements,
    hasSelectedProducts,
    getCompletion3Products,
    toggleProduct,
    updateProductQty,
    getPhaseState
  }
})
